export default __webpack_public_path__ + "static/media/hex_duble_mix.15baa796.svg";